import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["models"];
import longTranslationsAr from "@data/translations_v2/ar/long.json";
import longTranslationsEn from "@data/translations_v2/en/long.json";
import carsCatalogData from "@data/cars-catalog-data/cars_catalog_data.json";
var LISTING_NEW_CARS = 'page_description/listing_new_cars';
var LISTING_USED_CARS = 'page_description/listing_used_cars';
var LISTING_AUTOS_PAGE = 'page_description/listing_autos_page';
var LISTING_MAKE_MODEL_YEAR = 'page_description/listing_make_model_year';
export function getPageDescription(lang, url, selectedOptions) {
  // Select translation object based on language
  var translations = lang === 'ar' ? longTranslationsAr : longTranslationsEn;

  // Define URL patterns and their corresponding translation keys
  var urlPatterns = [{
    pattern: /^(\/en)?\/autos\/new-cars/,
    key: LISTING_NEW_CARS,
    replacePlaceholders: false
  }, {
    pattern: /^(\/en)?\/autos\/used-cars/,
    key: LISTING_USED_CARS,
    replacePlaceholders: false
  }, {
    pattern: /^(\/en)?\/autos\/([^\/]+)\/([^\/]+)\/(\d{4})\/?$/,
    key: LISTING_MAKE_MODEL_YEAR,
    replacePlaceholders: true
  }, {
    pattern: /^(\/en)?\/autos\/([^\/]+)\/([^\/]+)\/?$/,
    key: LISTING_MAKE_MODEL_YEAR,
    replacePlaceholders: true
  }, {
    pattern: /^(\/en)?\/autos\/([^\/]+)\/?$/,
    key: LISTING_MAKE_MODEL_YEAR,
    replacePlaceholders: true
  }, {
    pattern: /^(\/en)?\/autos\/?$/,
    key: LISTING_AUTOS_PAGE,
    replacePlaceholders: false
  }];

  // Find matching pattern and return corresponding translation
  for (var _i = 0, _urlPatterns = urlPatterns; _i < _urlPatterns.length; _i++) {
    var _urlPatterns$_i = _urlPatterns[_i],
      pattern = _urlPatterns$_i.pattern,
      key = _urlPatterns$_i.key,
      shouldReplace = _urlPatterns$_i.replacePlaceholders;
    if (pattern.test(url)) {
      var _translations$web_com;
      var description = (translations === null || translations === void 0 ? void 0 : (_translations$web_com = translations.web_common) === null || _translations$web_com === void 0 ? void 0 : _translations$web_com[key]) || null;

      // Replace placeholders for make/model/year patterns
      if (description && shouldReplace) {
        description = replacePlaceholders(description, selectedOptions, lang);
      }
      var _splitByWords = splitByWords(description, 22),
        pageDescription1 = _splitByWords.first,
        pageDescription2 = _splitByWords.second;
      return {
        pageDescription1: pageDescription1,
        pageDescription2: pageDescription2
      };
    }
  }
  return {
    pageDescription1: null,
    pageDescription2: null
  };
}
function replacePlaceholders(description, selectedOptions, lang) {
  if (!description) return description;
  var placeholderValues = extractPlaceholderValues(selectedOptions, lang);
  // Replace placeholders in the description
  var result = description;
  result = result.replace(/{make}/g, placeholderValues.make);
  result = result.replace(/{model}/g, placeholderValues.model);
  result = result.replace(/{year}/g, placeholderValues.year);

  // Clean up extra spaces that might result from empty replacements
  result = result.replace(/\s+/g, ' ').trim();
  return result;
}
function extractPlaceholderValues(
// fullPageData: ISearchResultsRedux,
selectedOptions, lang) {
  var values = {
    make: '',
    model: '',
    year: ''
  };
  selectedOptions.forEach(function (option) {
    if (option.filterField === 'make_id') {
      // Use name_ar or name_en based on language
      var name = lang === 'ar' ? option.name_ar : option.name_en;
      values.make = name || option.name || '';
    } else if (option.filterField === 'model_id') {
      // Use name_ar or name_en based on language
      var _name = lang === 'ar' ? option.name_ar : option.name_en;
      values.model = _name || option.name || '';
    } else if (option.filterField === 'year' && option.range_values) {
      // Extract year from range_values
      // If from and to are the same, use one value, otherwise show range
      var from = option.range_values.from;
      var to = option.range_values.to;
      if (from && to) {
        values.year = from === to ? from : "".concat(from, "-").concat(to);
      } else if (from) {
        values.year = from;
      } else if (to) {
        values.year = to;
      }
    }
  });
  return values;
}
function splitByWords(text, wordCount) {
  if (!text) return {
    first: '',
    second: ''
  };
  var words = text.trim().split(/\s+/);
  var first = words.slice(0, wordCount).join(' ');
  var second = ' ' + words.slice(wordCount).join(' ');
  return {
    first: first,
    second: second
  };
}
export function getAutosMakeModelAboutData(url, selectedOptions) {
  // If no url or selectedOptions, return null
  if (!url || !selectedOptions || selectedOptions.length === 0) {
    return {
      makeData: null,
      modelData: null
    };
  }

  // Check if URL matches autos pages pattern
  var autosPattern = /^(\/en)?\/autos/;
  if (!autosPattern.test(url)) {
    return {
      makeData: null,
      modelData: null
    };
  }

  // Extract make and model from selectedOptions
  var makeOption = selectedOptions.find(function (opt) {
    return opt.filterField === 'make_id';
  });
  var modelOption = selectedOptions.find(function (opt) {
    return opt.filterField === 'model_id';
  });

  // Get make ID from selectedOptions
  var makeId = makeOption === null || makeOption === void 0 ? void 0 : makeOption.id;

  // If no make in selectedOptions, return null
  if (!makeId) {
    return {
      makeData: null,
      modelData: null
    };
  }

  // Find the make data by ID (convert string ID to number for comparison)
  var foundMake = carsCatalogData.find(function (makeItem) {
    return makeItem.id === Number(makeId);
  });
  if (!foundMake) {
    return {
      makeData: null,
      modelData: null
    };
  }

  // If model exists in selectedOptions, find the model data by ID
  var modelData = null;
  var modelId = modelOption === null || modelOption === void 0 ? void 0 : modelOption.id;
  if (modelId && foundMake.models) {
    modelData = foundMake.models.find(function (modelItem) {
      return modelItem.id === Number(modelId);
    }) || null;
  }

  // Remove models from makeData to avoid sending large data to client
  var models = foundMake.models,
    makeData = _objectWithoutProperties(foundMake, _excluded);
  return {
    makeData: makeData,
    modelData: modelData
  };
}
export function getFaqQuestions(autosAboutData, selectedOptions) {
  var _autosAboutData$model, _autosAboutData$makeD;
  // Check if we have a model in selectedOptions (model route)
  var hasModel = selectedOptions.some(function (opt) {
    return opt.filterField === 'model_id';
  });

  // If model route and modelData has FAQ questions, return model FAQs
  if (hasModel && (_autosAboutData$model = autosAboutData.modelData) !== null && _autosAboutData$model !== void 0 && _autosAboutData$model.faq_questions) {
    return autosAboutData.modelData.faq_questions;
  }

  // If make route and makeData has FAQ questions, return make FAQs
  if (!hasModel && (_autosAboutData$makeD = autosAboutData.makeData) !== null && _autosAboutData$makeD !== void 0 && _autosAboutData$makeD.faq_questions) {
    return autosAboutData.makeData.faq_questions;
  }

  // Return empty array if no FAQ questions found
  return [];
}